import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { formatApiErrorDetail } from "@/lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role === "business_owner" || u.role === "admin") navigate("/dashboard");
      else navigate("/directory");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="login-page">
      <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">Welcome back</h1>
      <p className="text-slate-500 mt-2 mb-8">Sign in to your DHD account.</p>
      <form onSubmit={onSubmit} className="bg-white rounded-xl border border-slate-200 p-6 space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700 block mb-2">Email</label>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700 block mb-2">Password</label>
          <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        </div>
        {error && <div className="text-sm text-red-600" data-testid="login-error">{error}</div>}
        <Button type="submit" disabled={loading} className="w-full bg-blue-700 hover:bg-blue-800" data-testid="login-submit">
          {loading ? "Signing in…" : "Sign in"}
        </Button>
        <div className="text-sm text-slate-500 text-center">
          New here? <Link to="/register" className="text-blue-700 hover:underline">Create an account</Link>
        </div>
      </form>
      <div className="mt-6 text-xs text-slate-500 bg-slate-100 rounded-lg p-4">
        <div className="font-medium text-slate-700 mb-1">Sample accounts</div>
        <div>admin@dhd.example.com · Admin@2026</div>
        <div>owner@dhd.example.com · Owner@2026</div>
        <div>consumer@dhd.example.com · Demo@2026</div>
        <div>mailclerk@dhd.example.com · Clerk@2026</div>
      </div>
    </div>
  );
}
